module.exports = __webpack_public_path__ + "img/Proposed_flag_of_Antarctica.0247fc9c.svg";